export default {
  quoteExternalLink (state) {
    return state.quoteExternalLink
  }
}



// WEBPACK FOOTER //
// ./src/modules/library/store/getters.js